import { Component, input, inject, effect, computed, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormGroup } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { CatalogService } from "@services/data/catalog.service";
import { AuthService } from "@services/core/auth.service";
import { BpmService } from "../../services/bpm.service";
import { SheetSelectComponent } from "app/core/components/sheet-select/sheet-select.component";

@Component({
    selector: 'app-request-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, NgSelectModule, SheetSelectComponent],
    templateUrl: './request-form.componet.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: []
})
export class RequestFormComponet {
    requestForm = input.required<FormGroup>();
    processSlug = input<string | undefined>(undefined);
    currentEntityCode = input<number | null>(null);

    entities: any[] = [];
    private catalogService = inject(CatalogService);
    private authService = inject(AuthService);
    private bpmService = inject(BpmService);

    /** Destino solo para procesos de transferencia (categoría BPM). */
    isTransfer = computed(() => this.bpmService.isTransferProcess(this.processSlug()));
    isUnsubscribe = computed(() => this.bpmService.isUnsubscribeProcess(this.processSlug()));

    constructor() {
        effect(() => {
            const catalog = this.catalogService.entities() ?? [];
            const assigned: any[] = (this.authService.sharingEntities() as any[]) || [];
            const current = this.currentEntityCode();
            const byCode = new Map(catalog.map((e: any) => [Number(e.code), e]));

            // Alcance del rol activo; en transferencia el destino puede ser otra entidad del catálogo
            // (fuera del alcance) excepto la de origen.
            if (this.isTransfer()) {
                this.entities = catalog
                    .filter((e: any) => e.code !== current && e.isActive !== false)
                    .map((e: any) => ({
                        ...e,
                        name: `${e.code} - ${e.name}`
                    }));
                return;
            }

            this.entities = assigned
                .map((e: any) => {
                    const code = Number(e.code ?? e.entityCode);
                    if (!Number.isFinite(code)) return null;
                    const cat = byCode.get(code);
                    const name = cat?.name ?? e.name ?? '';
                    const isActive = cat?.isActive ?? e.isActive;
                    if (isActive === false && Number(code) !== Number(current)) return null;
                    return { ...(cat || {}), ...e, code, name: `${code} - ${name}` };
                })
                .filter(Boolean) as any[];
        });
    }

    findEntity(code: any) {
        return this.entities.find(e => e.code === code)?.name || code;
    }
}
